import { library } from '@fortawesome/fontawesome-svg-core';
import { faMobile, faCashRegister, faCodeBranch } from '@fortawesome/free-solid-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';

library.add(fab, faMobile, faCashRegister, faCodeBranch);
